module.exports = __webpack_public_path__ + "static/media/add.17e357e3.svg";